import { range } from "lodash";
import React from "react";
import styles from "./inboxPlaceholder.css";
import { staticConfig } from "@fidget/common/config/static-config";

interface Props {
  text: string | undefined;
  numberElements?: number;
  withoutText?: boolean;
}

export const InboxPlaceholder: React.VFC<Props> = ({
  text,
  numberElements = staticConfig.inboxDefaultPlaceholderNumber
}: Props) => (
  <>
    <div
      className={styles.message}
      dangerouslySetInnerHTML={text ? { __html: text } : undefined}
    ></div>
    {range(0, numberElements).map((i) => (
      <div key={i} className={styles.message}></div>
    ))}
  </>
);
